import { CommonActions, GlobalDispatch } from 'stores';

export const showToast = (
	message: string,
	options?: {
		duration?: number;
		type?: 'SUCCESS' | 'WARNING' | 'ERROR' | 'INFO';
		key?: number;
	}
) => {
	GlobalDispatch(
		CommonActions.showToast({
			message,
			duration: options?.duration || 5000,
			type: options?.type || 'SUCCESS',
			key: options?.key || new Date().getTime(),
		})
	);
};
